import type { Locale } from "@xiaotian-vault/shared";

export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes)) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(value >= 10 || unit === 0 ? 0 : 1)} ${units[unit]}`;
}

export function formatDate(value: string | null, locale: string): string {
  if (!value) return "";
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeStyle: "short"
  }).format(new Date(value));
}

function localeParam(locale: Locale): "zh" | "en" {
  return locale === "zh-CN" ? "zh" : "en";
}

export function withLocaleParam(url: string, locale: Locale): string {
  const localized = new URL(url, window.location.origin);
  localized.searchParams.set("lang", localeParam(locale));
  return localized.toString();
}

export function shareUrl(token: string, locale?: Locale): string {
  const url = `${window.location.origin}/s/${token}`;
  return locale ? withLocaleParam(url, locale) : url;
}

export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return "0s";
  const rounded = Math.round(seconds);
  const minutes = Math.floor(rounded / 60);
  const remainingSeconds = rounded % 60;
  if (minutes <= 0) return `${remainingSeconds}s`;
  return `${minutes}m ${remainingSeconds.toString().padStart(2, "0")}s`;
}
